let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iZ6KJ")).then(() => parcelRequire('lIEfL'));